import styled from 'styled-components';
import { colors, fonts } from '../../settings';
import Text from '../Text';

export const StyledDropCont = styled.div`
  border-bottom: ${(props) => (props.open ? 'none' : `1px solid ${colors.grey3}`)};
  background-color: ${(props) => (props.open ? colors.grey1 : 'transparent')};
  transition: background-color 0.4s, border 0.4s;
  overflow: hidden;
`;

export const Link = styled.button`
  width: 100%;
  padding: 15px 20px;
  color: ${colors.grey2};
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  outline: none;
`;

export const StyledImg = styled.img`
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
  width: 50px;
  height: 50px;
`;

export const StyledTitle = styled(Text.H3)`
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  max-width: calc(100% - 65px);
`;

export const StyledToggle = styled.div`
  color: ${colors.grey3};
  font-family: ${fonts.icon};
`;

export const StyledContent = styled.div`
  padding: ${(props) => (props.open ? '5px 20px 20px' : '0px')};
  max-height: ${(props) => (props.open ? '1200px' : '0px')};
  transition: max-height ${(props) => (props.open ? '0.4s' : '0s')} cubic-bezier(0.55, 0.085, 0.68, 0.53);
  display: flex;
  flex-flow: row wrap;
`;

export const Container = styled.div`
  width: 100%;
`;
